// extracted by mini-css-extract-plugin
export var footer = "_mu-0";
export var inherit = "_mu-1";
export var input = "_mu-2";
export var modalContent = "_mu-3";
export var quillEditor = "_mu-4";
export var subtitle = "_mu-5";